import type {Address} from "@/scripts/Common";

const createNewAddress = () => {
    const address: Address = {
        id: 0,
        street: '',
        town: '',
        zipCode: '',
    }

    return address;
}
export {
    createNewAddress,
}
